import { render, staticRenderFns } from "./currency-dropdown.vue?vue&type=template&id=70934f54&scoped=true&"
import script from "./currency-dropdown.vue?vue&type=script&lang=js&"
export * from "./currency-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70934f54",
  null
  
)

export default component.exports